import styled from 'styled-components';
import { Helpers } from '@origin-digital/style-guide';

export const VerticalLayout = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;

  > *:last-child {
    margin-bottom: 0;
  }
`;

export const VerticalLayoutItem = styled.div`
  margin-bottom: 12px;

  ${Helpers.media.LG`
    margin-bottom: 16px;
  `};
`;
